'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';

/**
 * @class VZTcAddon
 * @extends HTMLElement
 * @description Handles Teams Calling addon functionality
 */
export default class VZTcAddon extends HTMLElement {
    constructor() {
        super();
        this.boundHandleClick = this.handleClick.bind(this);
    }

    /**
     * @function connectedCallback
     * @description Lifecycle callback when element is added to the DOM
     */
    connectedCallback() {
        this.toggleButton = this.querySelector('.js-addon-btn-toggle');
        this.checkbox = this.querySelector('.custom-control-input');

        if (this.toggleButton) {
            this.toggleButton.addEventListener('click', this.boundHandleClick);
        }
    }

    /**
     * @function disconnectedCallback
     * @description Removes event listeners when element is removed from the DOM
     */
    disconnectedCallback() {
        if (this.toggleButton) {
            this.toggleButton.removeEventListener('click', this.boundHandleClick);
        }
    }

    /**
     * @function handleClick
     * @description Handles the click event on the toggle button
     * @param {Event} event - The click event
     */
    handleClick(event) {
        event.preventDefault();
        if (this.checkbox) {
            this.checkbox.checked = !this.checkbox.checked;
            this.checkbox.dispatchEvent(new Event('change'));

            const addText = this.toggleButton.querySelector('.js-addon-btn-add');
            const removeText = this.toggleButton.querySelector('.js-addon-btn-remove');

            addText.classList.toggle(CONST.classes.dNone);
            removeText.classList.toggle(CONST.classes.dNone);
            this.classList.toggle('info-card--bordered-primary');

            // Emit configuration update event
            const questionId = this.getAttribute('data-question-id');
            const productId = this.getAttribute('data-product-id');

            const configUpdateEvent = new CustomEvent('teamscalling:configupdate', {
                bubbles: true,
                detail: {
                    type: 'businessRulesAddon',
                    subType: this.subQuestionType,
                    questionId,
                    value: this.checkbox.checked ? { pid: productId } : null
                }
            });
            this.dispatchEvent(configUpdateEvent);
        }
    }
}

customElements.define('vz-tc-addon', VZTcAddon);
